"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Section = void 0;

var react_1 = __importStar(require("react"));

var components_utils_1 = require("@conte-ltd/components-utils");

function Section(props) {
  return react_1.default.createElement(react_1.default.Fragment, null);
}

exports.Section = Section;

Section.getCollectionNode = function getCollectionNode(props) {
  var children, heading, content, items, other;
  return __generator(this, function (_a) {
    switch (_a.label) {
      case 0:
        children = props.children, heading = props.heading, content = props.content, items = props.items, other = __rest(props, ["children", "heading", "content", "items"]);
        return [4
        /*yield*/
        , {
          type: 'section',
          props: other,
          hasChildNodes: true,
          rendered: heading !== null && heading !== void 0 ? heading : content,
          'aria-label': props['aria-label'],
          childNodes: function childNodes() {
            var items_1, items_1_1, item, e_1_1, items_2;

            var e_1, _a;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (!(typeof children === 'function')) return [3
                  /*break*/
                  , 9];

                  if (!items) {
                    throw new Error('props.children was a function but props.items is missing');
                  }

                  _b.label = 1;

                case 1:
                  _b.trys.push([1, 6, 7, 8]);

                  items_1 = __values(items), items_1_1 = items_1.next();
                  _b.label = 2;

                case 2:
                  if (!!items_1_1.done) return [3
                  /*break*/
                  , 5];
                  item = items_1_1.value;
                  return [4
                  /*yield*/
                  , {
                    type: (0, components_utils_1.hasChildren)(item) ? 'section' : 'item',
                    value: item,
                    renderer: children
                  }];

                case 3:
                  _b.sent();

                  _b.label = 4;

                case 4:
                  items_1_1 = items_1.next();
                  return [3
                  /*break*/
                  , 2];

                case 5:
                  return [3
                  /*break*/
                  , 8];

                case 6:
                  e_1_1 = _b.sent();
                  e_1 = {
                    error: e_1_1
                  };
                  return [3
                  /*break*/
                  , 8];

                case 7:
                  try {
                    if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                  } finally {
                    if (e_1) throw e_1.error;
                  }

                  return [7
                  /*endfinally*/
                  ];

                case 8:
                  return [3
                  /*break*/
                  , 11];

                case 9:
                  items_2 = [];
                  react_1.Children.forEach(children, function (child) {
                    if (typeof child.type === 'string' ? child.type === 'Section' : child.type.name == 'Section') {
                      items_2.push({
                        type: 'section',
                        element: child
                      });
                    } else {
                      items_2.push({
                        type: 'item',
                        element: child
                      });
                    }
                  });
                  return [5
                  /*yield**/
                  , __values(items_2)];

                case 10:
                  _b.sent();

                  _b.label = 11;

                case 11:
                  return [2
                  /*return*/
                  ];
              }
            });
          }
        }];

      case 1:
        _a.sent();

        return [2
        /*return*/
        ];
    }
  });
};